export default class TemplatesClient {
    constructor(apiClient) {
        this.templateUri = '/v3/templates';
        this.apiClient = apiClient;
        this.postTemplate = this.postTemplate.bind(this);
        this.putTemplate = this.putTemplate.bind(this);
        this.deleteTemplate = this.deleteTemplate.bind(this);
        this.getTemplates = this.getTemplates.bind(this);
        this.getTemplate = this.getTemplate.bind(this);
    }
    postTemplate(data, config) {
        return this.apiClient.post(this.templateUri, data, config);
    }
    putTemplate(id, data, config) {
        return this.apiClient.put(`${this.templateUri}/${id}`, data, config);
    }
    deleteTemplate(id, config) {
        return this.apiClient.delete(`${this.templateUri}/${id}`, config);
    }
    // Returns all templates available to the user by default
    // Accepts the following query params for team members:
    // owner: ownerId
    // partner: partnerId
    // type: templateType
    getTemplates(config) {
        return this.apiClient.get(this.templateUri, config);
    }
    getTemplate(id, config) {
        return this.apiClient.get(`${this.templateUri}/${id}`, config);
    }
}
